module.exports = "https://cdn-assessment.mathletics.com/app/122/assets/fonts/13a82fa49eeaf93d6b525a3dad74942b.woff2";